import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const VolMuteIcon = ({ color, ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26' {...rest} fill={color}>
    <path d='M 3.5 2 C 3.125 2.066406 2.824219 2.339844 2.71875 2.703125 C 2.613281 3.070313 2.722656 3.460938 3 3.71875 L 23 23.71875 C 23.242188 24.015625 23.628906 24.152344 24.003906 24.066406 C 24.375 23.980469 24.667969 23.6875 24.753906 23.316406 C 24.839844 22.941406 24.703125 22.554688 24.40625 22.3125 L 17 14.90625 L 17 3.3125 C 17 2.046875 15.894531 1.730469 15.03125 2.59375 L 9.8125 7.71875 L 4.40625 2.3125 C 4.199219 2.089844 3.898438 1.976563 3.59375 2 C 3.5625 2 3.53125 2 3.5 2 Z M 5 9.0625 C 4.449219 9.0625 4 9.511719 4 10.0625 L 4 16.0625 C 4 16.613281 4.449219 17.0625 5 17.0625 L 8.4375 17.0625 L 15 23.46875 C 16 24.46875 17 23.957031 17 22.59375 L 17 20.03125 L 6.03125 9.0625 Z' />
  </svg>
)
/* --------------------------------------------- */
VolMuteIcon.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
VolMuteIcon.defaultProps = {
  color: 'transparent',
  style: {
    width: 25,
    height: 25
  }
}
/* --------------------------------------------- */
export default VolMuteIcon
/* --------------------------------------------- */
